import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HostPortalClient, ShipmentUpdateDTO, ShippingOption, WebinarShipment } from 'src/app/Services/WOWApi.Service';
import { CommonServices } from 'src/app/Common/CommonServices';

@Component({
  selector: 'app-tracking-dialog',
  standalone: false,
  templateUrl: './tracking-dialog.component.html',
  styleUrls: ['./tracking-dialog.component.css']
})
export class TrackingDialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<TrackingDialogComponent>);
  private readonly data = inject(MAT_DIALOG_DATA) as {
    shipment: WebinarShipment;
    shippingOptions: ShippingOption[];
  };
  private readonly hostPortalClient = inject(HostPortalClient);
  private readonly commonServices = inject(CommonServices);

  shippingOptions: ShippingOption[] = [];
  selectedOptionId: number | null = null;
  trackingId = '';
  shippedOn: Date = new Date();
  shippingPrice: number | null = null;
  isSaving = false;

  ngOnInit(): void {
    this.shippingOptions = this.data.shippingOptions || [];
    const shipment = this.data.shipment;
    this.selectedOptionId = shipment?.shippingOptionId
      || shipment?.shippingOption?.id
      || null;
    this.trackingId = shipment?.trackingId || shipment?.uspsTrackingNumber || '';
    this.shippedOn = shipment?.shippedOn ? new Date(shipment.shippedOn) : new Date();
    this.shippingPrice = shipment?.shippingPrice ?? shipment?.uspsPostageAmount ?? null;
  }

  get canSave(): boolean {
    return !!this.selectedOptionId && !!this.trackingId?.trim() && !this.isSaving;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (!this.canSave) {
      this.commonServices.showMessage('Error', 'Please select a carrier and enter a tracking number');
      return;
    }

    this.isSaving = true;
    const body = ShipmentUpdateDTO.fromJS({
      shippingId: this.data.shipment.id,
      shippingOptionId: this.selectedOptionId,
      trackingId: this.trackingId.trim(),
      shippingPrice: this.shippingPrice ?? 0,
      shippedOn: this.shippedOn || new Date()
    });

    this.hostPortalClient.updateShipment(body).subscribe({
      next: (success) => {
        this.isSaving = false;
        if (!success) {
          this.commonServices.showMessage('Error', 'Could not save tracking information');
          return;
        }

        const selectedOption = this.shippingOptions.find(option => option.id === this.selectedOptionId);
        this.dialogRef.close({
          success: true,
          shipmentId: this.data.shipment.id,
          shippingOptionId: this.selectedOptionId,
          shippingOption: selectedOption,
          trackingId: this.trackingId.trim(),
          shippedOn: this.shippedOn,
          shippingPrice: this.shippingPrice
        });
      },
      error: () => {
        this.isSaving = false;
        this.commonServices.showMessage('Error', 'Could not save tracking information');
      }
    });
  }
}
